module.exports = Math;